import React from 'react';
import { formatCurrency, formatPercent } from 'utils';
import usePolicy from 'hooks/usePolicy';
import { TooltipBase } from './';

const TooltipCharges = ({ payload }: any) => {
  const data = payload[0] && payload[0].payload;
  const policyHelper = usePolicy();

  if (!data || data.type === 'gap') return null;
  const platform = policyHelper.humanizePolicyPlatform(data.platform);
  const provider = policyHelper.humanizePolicyProvider(data.provider);
  return (
    <TooltipBase>
      <p>
        Policy owner: <b>{data.owner}</b>
      </p>
      <p>
        Platform: <b>{platform}</b>
      </p>
      <p>
        Policy provider: <b>{provider}</b>
      </p>
      <p>
        Policy type: <b>{data.type}</b>
      </p>
      <p>
        Policy number: <b>{data.number}</b>
      </p>
      <p>
        Total charges (£):{' '}
        <b>{formatCurrency(data.total_excluding_adviser_cash_value)}</b>
      </p>
      <p>
        Total charges (%):{' '}
        <b>{formatPercent(data.total_excluding_adviser_percentage_value)}</b>
      </p>
    </TooltipBase>
  );
};

export default TooltipCharges;
